import type React from "react"
import { useTranslation } from "react-i18next"

import { ResourceField } from "@/components/fields/resource-field"
import { type ResourceName, resourceI18nItemKey } from "@/models/resource"

interface IntervalDataResourceFilterProps {
  onResourceChange: (resource: ResourceName) => void
  options: readonly ResourceName[]
  value: ResourceName
}

const isSelectableResource = (
  value: string,
  selectable: readonly ResourceName[]
): value is ResourceName => (selectable as readonly string[]).includes(value)

export const IntervalDataResourceFilter: React.FC<
  IntervalDataResourceFilterProps
> = ({ onResourceChange, options, value }) => {
  const { t } = useTranslation("common")
  const selectOptions = options.map((resource) => ({
    label: t(`fields.resource.items.${resourceI18nItemKey[resource]}`),
    value: resource,
  }))

  const handleChange = (nextValue: string) => {
    if (!isSelectableResource(nextValue, options)) {
      return
    }
    onResourceChange(nextValue)
  }

  return (
    <ResourceField
      onChange={handleChange}
      options={selectOptions}
      value={value}
    />
  )
}
